export class DcEmailModel{
    to:string;
    dcNo: string;
    subject:string;
    html: string
}